module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('form', {
    staticClass: "form form-horizonal",
    attrs: {
      "data-vv-scope": "nationalRegisterStatusForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Condition")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_c('div', {
    staticClass: "row form-inline"
  }, [_vm._m(0), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'disturbanceInstanceList',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('checkBoxPanel', {
    ref: "disturbanceCheckboxPanel",
    attrs: {
      "numColumns": 4,
      "lookupList": _vm.disturbanceList,
      "fieldName": 'disturbanceTypeId',
      "name": _vm.qaqcFieldId + 'NRSDisturbanceCB'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.historicalRegisterStatus.disturbancePercent),
      expression: "historicalRegisterStatus.disturbancePercent"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|between:0,100'),
      expression: "'required|between:0,100'"
    }],
    staticClass: "form-control form-inline",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "10",
      "max": "100",
      "name": "disturbance percentage"
    },
    domProps: {
      "value": (_vm.historicalRegisterStatus.disturbancePercent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.historicalRegisterStatus, "disturbancePercent", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'disturbancePercent',
      "hasAppend": false
    }
  }) : _vm._e()], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("NRHP SIGNIFICANCE")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('label', [_vm._v("Period(s) of significance")]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'significantPeriodInstanceList',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.isConditionReport && !_vm.qaqcEnabled
    }
  }, [_c('checkBoxPanel', {
    ref: "significantPeriodCheckboxPanel",
    attrs: {
      "numColumns": 4,
      "lookupList": _vm.significantPeriodList,
      "fieldName": 'significantPeriodId',
      "name": _vm.qaqcFieldId + 'RSSignificantPeriodCB'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-inline"
  }, [_c('label', [_vm._v("Theme(s)")]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'themeInstanceList',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.isConditionReport && !_vm.qaqcEnabled
    }
  }, [_c('checkBoxPanel', {
    ref: "themeCheckboxPanel",
    attrs: {
      "numColumns": 4,
      "lookupList": _vm.themeList,
      "fieldName": 'themeId',
      "name": _vm.qaqcFieldId + 'NRSThemeCB'
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-inline"
  }, [_c('label', {
    staticClass: "col-md-3 col-md-offset-2"
  }, [_vm._v("Discuss period of significance")]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'periodDescription',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.isConditionReport && !_vm.qaqcEnabled
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.historicalRegisterStatus.periodDescription),
      expression: "historicalRegisterStatus.periodDescription"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.isConditionReport || _vm.qaqcEnabled
      }),
      expression: "{ required: !isConditionReport || qaqcEnabled }"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6"
    },
    domProps: {
      "value": (_vm.historicalRegisterStatus.periodDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.historicalRegisterStatus, "periodDescription", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (!(_vm.qaqcEnabled || _vm.formDisabled)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.saveNRHP
    }
  }, [_vm._v("Save")])])]) : _vm._e(), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldFooter', {
    attrs: {
      "qaqcProgressDto": _vm.qaqcProgressDto,
      "qaqcSelection": _vm.qaqcSelection,
      "sectionName": 'nationalRegisterStatus',
      "completeSection": _vm.completeSection
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_vm._v("Disturbance"), _c('span', [_vm._v("Check all that apply; indicate specific areas of disturbance and vandalism on a copy of the site map")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Percent of property badly disturbed "), _c('span', [_vm._v("As of this recording date, to nearest 10%")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-baa73650"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteForm/NationalRegisterStatusForm.vue
// module id = 990
// module chunks = 1